import module from 'finanzas/module.js'

function FinanzasReporteFacturasExportarXMLService ($api) {
  this.get = function (data) {
    return $api.post('/kendu/finanzas/reportefacturas/documentos/xml', {
      data: data,
    })
  }
}

module.service('FinanzasReporteFacturasExportarXML', FinanzasReporteFacturasExportarXMLService)




// WEBPACK FOOTER //
// ./src/finanzas/services/FinanzasReporteFacturasExportarXML.js